
import { useState, useEffect } from 'react';
import { getSubscriptionStatus, getTrialDaysRemaining } from '@/utils/subscriptionService';

export const useSubscription = () => {
  const [subscriptionStatus, setSubscriptionStatus] = useState<'active' | 'inactive' | 'trial' | 'expired'>('inactive');
  const [trialDaysLeft, setTrialDaysLeft] = useState<number | undefined>(undefined);
  const [subscriptionPlan, setSubscriptionPlan] = useState<string | undefined>(undefined);
  const [subscriptionFeatures, setSubscriptionFeatures] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchSubscriptionData = async () => {
      setIsLoading(true);
      try {
        // Get user's current subscription status
        const userId = 'current-user'; // In a real app, get this from auth context
        const subscription = await getSubscriptionStatus(userId);
        
        setSubscriptionStatus(subscription.status);
        setSubscriptionPlan(subscription.plan);
        setSubscriptionFeatures(subscription.features);
        
        // If on trial, get days remaining
        if (subscription.status === 'trial') {
          setTrialDaysLeft(subscription.daysRemaining || getTrialDaysRemaining(userId));
        } else if (subscription.status === 'expired') {
          setTrialDaysLeft(0);
        }
      } catch (error) {
        console.error('Error fetching subscription data:', error);
        // Default to 'inactive' if there's an error
        setSubscriptionStatus('inactive');
      } finally {
        setIsLoading(false);
      }
    };

    fetchSubscriptionData();
  }, []);

  return {
    subscriptionStatus,
    trialDaysLeft,
    subscriptionPlan,
    subscriptionFeatures,
    isLoading,
  };
};
